import { render, staticRenderFns } from "./NoImageV2.vue?vue&type=template&id=624d49c8&scoped=true&"
import script from "./NoImageV2.vue?vue&type=script&lang=js&"
export * from "./NoImageV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624d49c8",
  null
  
)

export default component.exports